import { MyHTTPConnection } from "../global/MyHTTPConnection";
import { MarkerType } from '../models/MarkerTypeModel.js';

export class MarkerTypeService {
  static async getMarkerTypes() {
    const response = await fetch(MyHTTPConnection.HTTP_URL + 'markertype/');
    const data = await response.json();
    return data.map(markerType => new MarkerType(markerType));
  }
}